import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'

import JsonViewModal from '../../viewJson'
import HeaderExpandedRecord from './header/HeaderExpandedRecord'
import AddressRecordBusiness from './address/AddressRecordBusiness'
import PhoneNumbersExpandedRecord from './PhoneNumbers/PhoneNumbers'
import EmailsExpandedRecord from './emails/EmailsExpandedRecord'
import WebsiteExpandedRecord from './websites/WebsiteExpandedRecord'
import PrimaryCategory from './PrimaryCategory/PrimaryCategory'
import CategoriesBusiness from './categories/CategoriesBusiness'
import SIC from './SIC/SIC'
import Descriptions from './description/Description'
import CompanyDetails from './CompanyDetails/CompanyDetails'
import Reviews from './reviews/reviews'
import Features from './features/Feature'
import SourceURLs from './sourceURLs/sourceURLs'
import useStore from '../BusinessStore/Store'
import { useHistory } from 'react-router-dom'
import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import useEscapeKey from '../../utils/useEscapeKey'

function ExpandedRecordsBusiness ({
  recordData,
  onClose,
  isLoadingRecord,
  errorNotEnoughCredits,
  setErrorNotEnoughCredits,
  snackBarStateError
}) {
  const { setShouldRefetch } = useStore()
  const history = useHistory()

  const [isVisible, setIsVisible] = useState(false)
  const [isJsonModalVisible, setIsJsonModalVisible] = useState(false) // State for JSON modal visibility
  const toggleJsonModal = () => {
    setIsJsonModalVisible(true) // Toggle JSON modal visibility
  }
  const [record, setRecord] = useState(recordData) // Manage record as internal state
  const [errorAlert, setErrorAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: ''
  })

  useEffect(() => {
    // Trigger the slide-in effect when the component mounts
    if (record || isLoadingRecord) {
      const timeoutId = setTimeout(() => {
        setIsVisible(true)
      }, 1)
      return () => clearTimeout(timeoutId)
    }
  }, [record, isLoadingRecord])

  const handleClose = () => {
    if (!isJsonModalVisible) {
      // Start the slide-out effect
      setIsVisible(false)
      // Use a timeout to match the CSS transition duration
      setTimeout(() => {
        onClose()
      }, 250) // Adjust timeout to match your CSS transition
    }
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    setRecord(recordData)
    setShouldRefetch(true)
  }, [recordData, setShouldRefetch])

  useEffect(() => {
    if (snackBarStateError) {
      setErrorAlert({
        open: true,
        title: 'Requesting too many records',
        body: "The number of records you're requesting exceeds the available records remaining on your plan. Try narrowing your search or upgrade your account for more record credits.",
        color: '#000000'
      })
    }
    if (errorNotEnoughCredits) {
      setErrorNotEnoughCredits(false)
    }
  }, [snackBarStateError, errorNotEnoughCredits, setErrorNotEnoughCredits])

  if (isLoadingRecord || !record) {
    return (
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={styles.modalContentExpandedRecord}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: isVisible ? 'translateX(0)' : 'translateX(100%)'
          }}
          onClick={e => e.stopPropagation()}
        >
          <p>Loading details...</p>
        </div>

        <BaseAlert
          open={errorAlert.open}
          title={errorAlert.title}
          body={errorAlert.body}
          color={errorAlert.color}
          actions={[
            {
              label: 'Upgrade account',
              onClick: () => history.push('/settings/billing/subscription')
            },
            {
              label: 'Ok',
              onClick: () => setErrorAlert(prev => ({ ...prev, open: false }))
            }
          ]}
          onClose={() => setErrorAlert(prev => ({ ...prev, open: false }))}
          style={{ width: '320px' }}
        />
      </div>
    )
  }

  return (
    <div>
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={`${styles.modalContentExpandedRecord} ${
            isVisible ? styles.modalVisible : ''
          }`}
          onClick={e => e.stopPropagation()}
        >
          <HeaderExpandedRecord
            record={record}
            handleClose={handleClose}
            toggleJsonModal={toggleJsonModal}
          />
          <AddressRecordBusiness record={record} />
          <div style={{ display: 'flex', marginBottom: '24px', gap: '20px' }}>
            <PhoneNumbersExpandedRecord record={record} />
            <EmailsExpandedRecord record={record} />
            <WebsiteExpandedRecord record={record} />
          </div>
          <hr className={styles.hrStyles} />
          <div
            style={{
              display: 'flex',
              marginTop: '22px',
              marginBottom: '20px',
              gap: '100px'
            }}
          >
            <PrimaryCategory record={record} />
            <SIC record={record} />
          </div>
          <div>
            <CategoriesBusiness record={record} />
          </div>
          <hr className={styles.hrStyles} />
          <Descriptions record={record} />
          <hr className={styles.hrStyles} />
          <CompanyDetails record={record} />
          <hr className={styles.hrStyles} />
          <Reviews record={record} />
          <hr className={styles.hrStyles} />
          <Features record={record} />
          <hr className={styles.hrStyles} />
          <SourceURLs record={record} />
        </div>
      </div>
      {isJsonModalVisible && (
        <JsonViewModal
          jsonData={record}
          onClose={() => setIsJsonModalVisible(false)}
        />
      )}
    </div>
  )
}

export default ExpandedRecordsBusiness
